<template>
  <header>
    <a @click="() => $router.push('/')" class="logo"
      >{ Baraka<span>Dev</span> }</a
    >
    <ul
      class="links"
      v-if="$route.name != 'Dashboard' && $route.name !== 'Create'"
    >
      <li v-if="$route.name != 'Dashboard' && $route.name !== 'Create'">
        <router-link class="item" to="/">Home</router-link>
      </li>
      <li v-if="$route.name != 'Dashboard' && $route.name !== 'Create'">
        <router-link class="item" to="/projects">Portfolio</router-link>
      </li>
      <li v-if="$route.name != 'Dashboard' && $route.name !== 'Create'">
        <router-link class="item" to="/technologies">Technologies</router-link>
      </li>
      <li v-if="$route.name != 'Dashboard' && $route.name !== 'Create'">
        <router-link class="item" to="/socials">Socials</router-link>
      </li>
    </ul>
    <ul class="links" v-else>
      <li>
        <router-link class="item" to="/dashboard">Dashboard</router-link>
      </li>
      <li>
        <router-link class="item" to="/create">Create</router-link>
      </li>
      <li>
        <a class="item" @click="logout" to="">Logout</a>
      </li>
    </ul>
    <!-- <a class="link"><i class="material-icons-outlined menu">menu</i></a> -->
  </header>
</template>

<script>
import { useStore } from "vuex";
export default {
  props: [],
  setup() {
    const store = useStore();
    const logout = () => {
      store.dispatch("LogOut");
    };
    return {
      logout,
    };
  },
};
</script>

<style scoped>
header {
  width: 100%;
  height: 50px;
  padding: 0;
  background-color: #fff !important;
  box-shadow: 1px 1px 0px rgba(78, 56, 56, 0.2) !important;

  position: fixed;
  top: 0;
  margin: 0;
  z-index: 99;
}
.logo {
  float: left;
  display: block;
  color: black;
  font-weight: 700;
  text-align: center;
  padding: 16px 16px;
  text-decoration: none;
}
.logo span {
  color: #765cd1;
  font-weight: 500;
}
.menu {
  display: none;
  float: right;
}

.links {
  list-style-type: none;
  margin: 0;
  padding: 0;
  float: right;
  overflow: hidden;
}
.link {
  display: block;
  color: black;
  text-align: center;
  padding: 14px 16px;
  text-decoration: none;
}
ul li {
  float: left;
}
.item {
  margin: 0;
  display: block;
  color: black;
  text-align: center;
  padding: 14px 16px;
  text-decoration: none;
  font-weight: 400;
}
li:after {
  display: block;
  content: "";
  border-bottom: solid 2px #765cd1;
  transform: scaleX(0);
  transition: transform 250ms ease-in-out;
}
li:hover:after {
  transform: scaleX(1);
}
.item:after {
  transform-origin: 0% 50%;
}

@media only screen and (min-width: 601px) {
  .router-link-exact-active {
    color: #765cd1;
  }
  .router-link-active {
    color: #765cd1;
    border-bottom: solid 2px #765cd1;
  }
  .router-link-exact-active :hover {
    color: #765cd1;
  }
}

/*  */
@media only screen and (max-width: 601px) {
  header {
    width: 100%;
    height: 50px;
    padding: 0;
    background-color: #fff !important;
    box-shadow: 1px 1px 0px rgba(78, 56, 56, 0.2) !important;
    position: fixed;
    top: 0;
    margin: 0;
    z-index: 99;
  }
  ul {
    display: none;
  }
  .menu {
    display: block;
  }
}
</style>
